import {
  CREATING_CUSTOM_FIELD_REQUEST, CREATING_CUSTOM_FIELD_SUCCEEDED, CREATING_CUSTOM_FIELD_FAILED,
  UPDATING_CUSTOM_FIELD_REQUEST, UPDATING_CUSTOM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FIELD_FAILED,
  FETCHING_CUSTOM_FIELD_REQUEST, FETCHING_CUSTOM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FIELD_FAILED,
  FETCHING_CUSTOM_FIELDS_REQUEST, FETCHING_CUSTOM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FIELDS_FAILED,
  DELETING_CUSTOM_FIELD_REQUEST, DELETING_CUSTOM_FIELD_SUCCEEDED, DELETING_CUSTOM_FIELD_FAILED,REORDERING_CUSTOM_FIELD_REQUEST,
  REORDERING_CUSTOM_FIELD_SUCCEEDED,REORDERING_CUSTOM_FIELD_FAILED, UPDATING_GOOGLE_ANALYTICS_REQUEST
} from 'src/legacy/redux/actions/actionTypes.jsx'; 

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  creating: false,
  updating: false,
  error: null
}

function customFieldReducer(state = initialState, action) {
  switch (action.type) {
    case CREATING_CUSTOM_FIELD_REQUEST:
      return Object.assign({}, state, {
        ...state,
        creating: true
      })
    
    case CREATING_CUSTOM_FIELD_SUCCEEDED:{
      var items = state.items.slice();
      items.splice(state.items.length, 0, action.payload);

      return Object.assign({}, state, {
        ...state,
        creating: false,
        items: items
      })
    }
      case CREATING_CUSTOM_FIELD_FAILED:
        return Object.assign({}, state, {
          ...state,
          creating: false,
          error: action.payload
        })

      case UPDATING_CUSTOM_FIELD_REQUEST: {
        return Object.assign({}, state, {
          ...state,
          updating: true,
        })
      }

        case UPDATING_CUSTOM_FIELD_SUCCEEDED: {
          var id = action.payload.id;
          let items = state.items.map(item => {
            if (item.id != id) {
              return item;
            }

            return {
              ...item, 
              ...action.payload.response
            };
          }); 
          
          return {
            ...state,
            updating: false,
            items
          };
      }
      

      case UPDATING_CUSTOM_FIELD_FAILED:{
        return Object.assign({}, state, {
          ...state,
          updating: false,
          error: action.payload.error
        })
      }
        
      case FETCHING_CUSTOM_FIELDS_REQUEST: 
        return Object.assign({}, state, {
          ...state,
          loading: true,
          isFetched: false
        })
      
      case FETCHING_CUSTOM_FIELDS_SUCCEEDED:{
        let items = action.payload

        return Object.assign({}, state, {
          ...state,
          loading: false,
          items: items,
          isFetched: true
        })
      }

      case FETCHING_CUSTOM_FIELDS_FAILED:
        return Object.assign({}, state, {
          ...state,
          loading: false,
          error: action.payload
        })

      case DELETING_CUSTOM_FIELD_REQUEST:
        return Object.assign({}, state, {
          ...state,
          deleting: true
        })

      case DELETING_CUSTOM_FIELD_SUCCEEDED:{
        let items = state.items.filter((item, index) => {
          return item.id != action.payload.id;
        })

        return Object.assign({}, state, {
          ...state,
          deleting: false,
          items: items
        })
      }

      case DELETING_CUSTOM_FIELD_FAILED:
        return Object.assign({}, state, {
          ...state,
          deleting: false,
          error: action.payload
        })
       
      case REORDERING_CUSTOM_FIELD_REQUEST:{
        return Object.assign({}, state, {
          ...state,
        })  
      }

      case REORDERING_CUSTOM_FIELD_SUCCEEDED:{
        let items = action.payload
        return Object.assign({}, state, {
          ...state,
          items: items
        }) 
      }

      case REORDERING_CUSTOM_FIELD_FAILED:
        return Object.assign({}, state, {
          ...state,
          error: action.payload
        })

      default:
        return state;
  }
}

export { customFieldReducer };